import { label } from "@keel/core";
import { Stat } from "@keel/ui";

/** Home dashboard: who is away today. */
export function AwayTile({
  data,
}: {
  data: { headcount: number; requested: number; away: { name: string; type: string }[] };
}) {
  const away = data.away;
  return (
    <Stat
      label="Away today"
      value={`${away.length} of ${data.headcount}`}
      href="/absences"
      foot={
        away.length
          ? away
              .slice(0, 2)
              .map((a) => `${a.name.split(" ")[0]} (${label(a.type)})`)
              .join(", ") + (data.requested ? ` · ${data.requested} to approve` : "")
          : data.requested
            ? `${data.requested} requests to approve`
            : "Everyone's in"
      }
    />
  );
}
